import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-software-prototyping',
  templateUrl: './software-prototyping.component.html',
  styleUrls: ['./software-prototyping.component.scss']
})
export class SoftwarePrototypingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
